<div *ngIf="message">
  <div class="alert" [ngClass]="getClass()" role="alert">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
    <strong>{{ getType() }}: </strong> {{ message }}.
  </div>
</div>
